export const invitationsSelector = (workspaceKey) => state => state.invitations[workspaceKey];